import { render, staticRenderFns } from "./MatterCapacities.vue?vue&type=template&id=2b763d7d&scoped=true"
import script from "./MatterCapacities.vue?vue&type=script&lang=js"
export * from "./MatterCapacities.vue?vue&type=script&lang=js"
import style0 from "./MatterCapacities.vue?vue&type=style&index=0&id=2b763d7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b763d7d",
  null
  
)

export default component.exports